// LOTE T1 — Balão de ajuda unificado (reaproveita Tooltip do shadcn/Radix).
// Visual: fundo marinho #003E62, texto branco, até 2 linhas, aparece em 300ms.
// Mobile: longpress (~450ms) abre; soltar fecha. Só segurar funciona no touch.
import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

export default function HelpTip({ label, title, side = "top", align = "center", asChild = true, children, maxLines = 2, delayDuration = 300, longPressMs = 450, disabled = false }) {
  const [open, setOpen] = React.useState(false);
  const timer = React.useRef(null);
  const text = title || label; // aceita `title` ou `label`
  if (disabled || !text) return <>{children}</>;

  const clearT = () => { if (timer.current) { clearTimeout(timer.current); timer.current = null; } };
  const onTouchStart = () => { clearT(); timer.current = setTimeout(() => setOpen(true), longPressMs); };
  const onTouchEnd = () => { clearT(); setOpen(false); };

  return (
    <TooltipPrimitive.Provider delayDuration={delayDuration} skipDelayDuration={100}>
      <TooltipPrimitive.Root open={open || undefined} onOpenChange={setOpen}>
        <TooltipPrimitive.Trigger
          asChild={asChild}
          onTouchStart={onTouchStart}
          onTouchEnd={onTouchEnd}
          onTouchCancel={onTouchEnd}
        >
          {children}
        </TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            side={side}
            align={align}
            sideOffset={6}
            className="z-50 rounded-md px-3 py-1.5 text-xs text-white shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0"
            style={{ backgroundColor: "#003E62", maxWidth: 240, lineHeight: 1.35, whiteSpace: "pre-line", display: "-webkit-box", WebkitLineClamp: maxLines, WebkitBoxOrient: "vertical", overflow: "hidden" }}
          >
            {text}
            <TooltipPrimitive.Arrow style={{ fill: "#003E62" }} />
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
}
